import { FC, useState } from 'react'
import { useLocation, useHistory } from 'react-router-dom'
import { IntroductionSectionList } from './IntroductionSectionList'

interface Props {
    userId:number
}

interface ITabs {
    id: string;
    name: string;
}

export const IntroductionWrapper: FC<Props> = ({ userId }) => {
    const [activeTab, setActiveTab] = useState('requests')
    const history = useHistory();
    const location = useLocation();

    const tabs:Array<ITabs> = [
        { id: 'requests', name: 'Requests' },
        { id: 'upcoming', name: 'Upcoming introductions' },
        { id: 'past', name: 'Past Introductions' },
    ]

    const changeTab = async (status: string) => {
        setActiveTab(status);
    }

    const renderContentOptionSelected = () => {
        return (<IntroductionSectionList section={activeTab} userId={userId} />);
    }

    return (
        <div className="tap-host-wrapper">
            <div className="tap-host-container gap-5 mt-5">
                <div className="tap-host-section">
                    <div className="card">
                        <div className="tap-add-experience-2-radio-row">
                            {tabs.map((item:any,index:number)=>(<div key={`experience-my-profile-${index}`} className={`tap-add-experience-2-radio-card h-fit w-50 ${item.id === activeTab ? 'tap-add-experience-2-radio-card--selected' : ''}`}>
                                <label className="tap-host-option p-6 pt-3 pb-3 w-100">
                                    <input type="radio" className="tap-host-radio-input"
                                        name="host_type"
                                        value="partner"
                                        checked={item.id == activeTab}
                                        onChange={()=>changeTab(item.id)}
                                    />
                                    <div className="tap-host-radio">
                                        <div className="tap-host-radio-outer"></div>
                                        <div className="tap-host-radio-inner"></div>
                                    </div>
                                    <div className="tap-host-option-label">{item.name}</div>
                                </label>
                            </div>))}
                        </div>
                    </div>
                </div>
                <div className="tap-host-footer">
                    {renderContentOptionSelected()}
                </div>
            </div>
        </div>

    )
}